/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.projects.ProjectLiveState
*/
export var ProjectLiveState;
(function (ProjectLiveState) {
    ProjectLiveState["UNKNOWN"] = "UNKNOWN";
    ProjectLiveState["STOPPED"] = "STOPPED";
    ProjectLiveState["STARTING"] = "STARTING";
    ProjectLiveState["RUNNING"] = "RUNNING";
    ProjectLiveState["STOPPING"] = "STOPPING";
})(ProjectLiveState || (ProjectLiveState = {}));
//# sourceMappingURL=ProjectLiveState.js.map